export const workspaceSelectChipOverrides = {
  classNames: {
    dropdown: 'workspaceSelectHiddenScrollbar',
  },
  styles: {
    dropdown: {
      width: 'max-content',
    },
    optionContent: {
      paddingTop: 8,
      paddingBottom: 8,
    },
  },
} as const;
